
import ResumePreviewDialog from "../ResumePreviewDialog";
import ResumePaymentDialog from "../ResumePaymentDialog";
import DownloadFormatDialog from "../DownloadFormatDialog";

interface ResumeDialogsProps {
  selectedResume: any;
  showPreview: boolean;
  showPayment: boolean;
  showFormatDialog: boolean;
  selectedFormat: "pdf" | "docx";
  isProcessing?: boolean;
  onPreviewChange: (open: boolean) => void;
  onPaymentChange: (open: boolean) => void;
  onFormatDialogChange: (open: boolean) => void;
  onPayment: (useCredit: boolean) => void;
  onFormatSelect: (format: "pdf" | "docx") => void;
}

const ResumeDialogs = ({
  selectedResume,
  showPreview,
  showPayment,
  showFormatDialog,
  selectedFormat,
  isProcessing,
  onPreviewChange,
  onPaymentChange,
  onFormatDialogChange,
  onPayment,
  onFormatSelect,
}: ResumeDialogsProps) => {
  return (
    <>
      <ResumePreviewDialog
        resume={selectedResume}
        open={showPreview}
        onOpenChange={onPreviewChange}
      />

      <ResumePaymentDialog
        open={showPayment}
        onOpenChange={onPaymentChange}
        onPayment={onPayment}
        selectedFormat={selectedFormat}
        isProcessing={isProcessing}
      />

      <DownloadFormatDialog
        open={showFormatDialog}
        onOpenChange={onFormatDialogChange}
        onFormatSelect={onFormatSelect}
        isPaid={selectedResume?.is_paid ?? false}
      />
    </>
  );
};

export default ResumeDialogs;
